<template>
  <div>
    <tooltip label="Change" type="default" placement="left">
      <a class="button button-table is-small" @click="change()">
        <i class="fa fa-random"></i>
      </a>
    </tooltip>
    <tooltip label="Remove" type="default" placement="left" v-if="parseInt($store.state.config.user.level) < 99">
      <a class="button button-table is-small" @click="remove()">
        <i class="fa fa-trash"></i>
      </a>
    </tooltip>
    <tooltip label="View" type="default" placement="left">
      <a class="button button-table is-small" @click="url()">
        <i class="fa fa-eye"></i>
      </a>
    </tooltip>
  </div>
</template>

<script>
  import Tooltip from 'vue-bulma-tooltip'
  import message from '../../utils/message'
  import Change from '../bi/change'
  export default {
    data () {
      return {}
    },
    props: {
      data: {
        type: Object,
        required: true
      }
    },
    components: {
      Tooltip
    },
    methods: {
      url () {
        window.open('#/services/service/' + this.data.id)
      },
      change () {
        let propsData = {
          context: this,
          service_id: parseInt(this.data.id),
          callback: 'openChange'
        }
        Change.openChange(propsData)
      },
      remove () {
        this.$http.post(this.$store.state.config.apiURL + '/bi/save_remove', {'remove': this.data.id}).then((response) => {
          this.$parent.loadData(true)
        }, (response) => {
        })
      },
      message (type, title, content) {
        let propsData = {
          title: title,
          message: content,
          type: type,
          direction: 'down',
          duration: 4500,
          showCloseButton: true
        }
        message.openMessage(propsData)
      }
    }
  }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// SaveTableButtons.vue?9a6036b0